import { combineReducers } from 'redux';
import ContestSeriesReducer from '../contests/reducer';
import AuthReducer from '../auth/reducer';

export default combineReducers({
  contestSeries: ContestSeriesReducer,
  auth: AuthReducer
});
